import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { boundariesCriteria, organisationTabCriteria, mobileAppCriteria } from '../../../utilities/epic-helpers';

import {
  FETCH_BRAND_AFFINITY_SUMMARYCARD,
  FETCH_BRAND_AFFINITY_SUMMARYCARD_ERROR,
  SET_BRAND_AFFINITY_SUMMARYCARD
} from '../../constants';

const summaryCard = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_BRAND_AFFINITY_SUMMARYCARD),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/brand-affinity/summary?${
          organisationTabCriteria(state$)
          }${
          boundariesCriteria(state$)
          }${
            mobileAppCriteria(state$)
          }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {
          return {
            type: SET_BRAND_AFFINITY_SUMMARYCARD,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_BRAND_AFFINITY_SUMMARYCARD_ERROR,
            error,
          })
        )
      )
    )
  );

export default summaryCard;
